export const ShadowStyles = {
  shadowLevel2: '0px 0.15px 0.45px rgba(0, 0, 0, 0.11), 0px 0.8px 1.8px rgba(0, 0, 0, 0.13)',
  shadowLevel4: '0px 0.3px 0.9px rgba(0, 0, 0, 0.11), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
  shadowLevel6: '0px 0px 6px rgba(0, 0, 0, 0.15), 0px 25.6px 57.6px rgba(0, 0, 0, 0.24)',
  shadowLevel8: '0px 0.6px 1.8px rgba(0, 0, 0, 0.11), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)',
  shadowLevel16: '0px 1.2px 3.6px rgba(0, 0, 0, 0.11), 0px 6.4px 14.4px rgba(0, 0, 0, 0.13)',
  shadowLevel32: '0px 2.4px 7.4px rgba(0, 0, 0, 0.18), 0px 12.8px 28.8px rgba(0, 0, 0, 0.22)',
  shadowLevel64: '0px 4.8px 14.4px rgba(0, 0, 0, 0.18), 0px 25.6px 57.6px rgba(0, 0, 0, 0.22)',
  shadowLevel2Darker: '0px 0.15px 0.45px rgba(0, 0, 0, 0.28), 0px 0.8px 1.8px rgba(0, 0, 0, 0.32)',
  shadowLevel4Darker: '0px 0.3px 0.9px rgba(0, 0, 0, 0.28), 0px 1.6px 3.6px rgba(0, 0, 0, 0.32)',
  shadowLevel8Darker: '0px 0.6px 1.8px rgba(0, 0, 0, 0.28), 0px 3.2px 7.2px rgba(0, 0, 0, 0.32)',
  shadowLevel16Darker: '0px 1.2px 3.6px rgba(0, 0, 0, 0.28), 0px 6.4px 14.4px rgba(0, 0, 0, 0.32)',
  shadowLevel32Darker: '0px 2.4px 7.4px rgba(0, 0, 0, 0.28), 0px 12.8px 28.8px rgba(0, 0, 0, 0.32)',
  shadowLevel64Darker: '0px 4.8px 14.4px rgba(0, 0, 0, 0.28), 0px 25.6px 57.6px rgba(0, 0, 0, 0.32)',
  buttonShadow: '0px 2px 4px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12)'
};
